import React from "react";
import './CohortCreation.css';
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

import CohortNameComponent from "./CohortNameComp/component";
import CohortTypeComponent from "./CohortCreationType/component";
import CohortAreaNameComponent from "./CohortAreaNameComp/component";
import CohortUserSelect from "./CohortSelectUserComp/component";
import CohortVMSelect from "./CohortSelectVMComp/component";
import CohortSuccessComponent from "./CohortSuccessMsg/component";

const CohortCreationComponent = (props) => {
  const steps = [
    "Cohort Name",
    "Cohort Type",
    "Area Name",
    "Select User",
    "Select Vending Machine"
  ];

  const navigate = useNavigate();
  const handleClick = () => navigate("/");
  const handleBack = () => navigate(-1)

  const isLastStep = props.activeStep === steps.length - 1;

  return (
    <div className="cohort-creation-container">
      <Sidebar />
      <div className="cohort-content">
        {/* Header */}
        <div className="cohort-header">
          <h2 className="cohort-title">
            <img 
              onClick={handleClick}
              className="back-arrow"
              src={leftArrow} 
              alt="Back" 
            />
            Create Cohort
          </h2>
        </div>

        {/* Stepper */}
        <Box className="stepper-box">
          <Stepper activeStep={props.activeStep} className="creation-stepper">
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        {/* Main Step Content Box */}
        <div className="step-content-wrapper">
          {props.isCohortCreated ? (
            <CohortSuccessComponent cohortId={props.cohortId} />
          ) : (
            <>
              {props.activeStep === 0 && (
                <CohortNameComponent
                  errors={props.errors}
                  cohortName={props.cohortName}
                  handleCohortNameChange={props.handleCohortNameChange}
                />
              )}
              {props.activeStep === 1 && (
                <CohortTypeComponent
                  errors={props.errors}
                  seedData={props.seedData}
                  cohortType={props.cohortType}
                  handleCohortTypeChange={props.handleCohortTypeChange}
                />
              )}
              {props.activeStep === 2 && (
                <CohortAreaNameComponent
                  errors={props.errors}
                  seedData={props.seedData}
                  cohortAreaName={props.cohortAreaName}
                  handleCohortAreaNameChange={props.handleCohortAreaNameChange}
                />
              )}
              {props.activeStep === 3 && (
                <CohortUserSelect
                  errors={props.errors}
                  seedData={props.seedData}
                  cohortSelectUser={props.cohortSelectUser}
                  handleCohortSelectUserChange={props.handleCohortSelectUserChange}
                />
              )}
              {props.activeStep === 4 && (
                <CohortVMSelect
                  errors={props.errors}
                  seedData={props.seedData}
                  cohortSelectVM={props.cohortSelectVM}
                  handleCohortSelectVMChange={props.handleCohortSelectVMChange}
                />
              )}

              
              <div className="step-actions">
                {props.activeStep > 0 && (
                  <Button
                    variant="outlined"
                    className="back-button"
                    onClick={props.handleClose}
                  >
                    Back
                  </Button>
                )}

{props.activeStep === steps.length - 1 ? ( 
              <Button
                className="continue-button"
                onClick={props.handleCreateNewCohort}
              >
                Submit
              </Button>
            ) : (
              <Button  className="continue-button" onClick={props.handleNext}>
               save and Continue
              </Button>
            )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CohortCreationComponent;
